const { items: wixData } = require('@wix/data');
async function queryAllItems(query, queryOptions = {}) {
  console.log('start query');
  let oldResults = await query.find(queryOptions);
  console.log(`found items: ${oldResults.items.length}`);
  const allItems = oldResults.items;
  while (oldResults.hasNext()) {
    oldResults = await oldResults.next();
    allItems.push(...oldResults.items);
  }
  console.log(`all items: ${allItems.length}`);
  return allItems;
}

async function getAllItems(collectionName) {
  const query = wixData.query(collectionName);
  return await queryAllItems(query);
}

module.exports = {
  queryAllItems,
  getAllItems,
};
